import { DOCUMENT } from '@angular/common';
import { InjectionToken, inject } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('tvd.window', {
  factory: () => {
    const view = inject(DOCUMENT).defaultView;
    if (!view) {
      throw new Error('Window is not available in current context');
    }
    return view;
  },
});
